<div class="form-group">
  <label [for]="id">{{title}} {{control | controlRequiredText}}</label>

  <input-time [control]="control" [id]="id" [title]="title" [placeholder]="placeholder"></input-time>

  <small *ngIf="messageFooter" class="form-text text-muted">{{messageFooter}}
  </small>

  <div-validation-message [control]="control" [messageRequired]="messageRequired" [messageCustomFn]="messageCustomFn">
  </div-validation-message>

</div>